/** @jsx jsx */
import { jsx } from "@trueskin-web/theme"

import CardsWithContent from "./cards-with-content"
import CardsWithCtas from "./cards-with-ctas"
import CardsWithFooter from "./cards-with-footer"
import ComplexCards from "./complex-cards"
import SimpleCards from "./simple-cards"

const Cards = () => {
  return (
    <div
      sx={{
        background: "#E7ECFF",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SimpleCards />
      <CardsWithFooter />
      <CardsWithContent />
      <CardsWithCtas />
      <ComplexCards />
    </div>
  )
}

export default Cards
